import React from 'react';
import { Link } from 'react-router-dom';

const TvCard = ({ item }) => {
  const getPosterCard = (posterpath) => {
    return `https://image.tmdb.org/t/p/w500/${posterpath}`;
  };
  return (
    <Link to={`/tv/${item.id}`}>
      <div
        style={{ backgroundImage: `url(${getPosterCard(item.poster_path)})` }}
        className="relative bg-top bg-no-repeat bg-cover rounded-2xl mb-4 pt-72"
      ></div>
      <h1>{item.title}</h1>
    </Link>
  );
};

export default TvCard;
